<template>
  <el-dialog class="confirm-media" :title="receiveData.title" :visible.sync="centerDialogVisible" @close="closeDialog"
             width="30%" center>
    <el-form label-position="right" label-width="90px" :model="receiveData" v-if="receiveData.title !== '提示'">
      <el-form-item label="媒体商ID：">
        <el-input v-model="receiveData.id" disabled></el-input>
      </el-form-item>
      <el-form-item label="公司名称：" v-if="receiveData.nature">
        <el-input v-model="receiveData.name" disabled></el-input>
      </el-form-item>
      <el-form-item label="姓名：" v-else>
        <el-input v-model="receiveData.name" disabled></el-input>
      </el-form-item>
      <el-form-item label="备注：" v-if="receiveData.remark">
        <el-input type="textarea" v-model="remark"></el-input>
      </el-form-item>
    </el-form>
    <p v-else>{{receiveData.toast}}</p>
    <span slot="footer" class="dialog-footer">
      <template v-if="receiveData.title !== '提示'">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button type="primary" @click="confirmDialog">{{receiveData.type}}</el-button>
      </template>
      <template v-else>
        <el-button type="primary" @click="closeDialog">关 闭</el-button>
      </template>

    </span>
  </el-dialog>

</template>
<script>
  export default {
    data () {
      return {
        remark: ''
      }
    },
    props: {
      dialogPragram: Object,
      isShowdialog: Boolean
    },
    computed: {
      receiveData () {
        return this.dialogPragram
      },
      centerDialogVisible () {
        this.remark = ''
        return this.isShowdialog
      }
    },
    methods: {
      closeDialog () {
        this.$emit('close')
      },
      confirmDialog () {
        var confirmData = {
          businessId: this.dialogPragram.BusinessId,
          status: this.dialogPragram.type === '通过' ? 3 : 2,
          remark: this.remark
        }
        this.dialogPragram.callback(confirmData).then(res => {
          this.$emit('close', res)
        })
      }
    }
  }
</script>
<style lang="scss">
  // @import "../../../common/scss/color.scss";
  .confirm-media {
    .el-dialog__header {
      background-color: #409eff;
      padding: 10px 20px 10px;
    }
    .el-dialog__title {
      color: #fff;
    }
    .el-dialog__headerbtn {
      transform: translateY(-50%);
      .el-dialog__close {
        color: #fff;
      }
    }

    .el-dialog__body {
      padding: 20px 25px 0px;
      p {
        font-size: 16px;
        font-weight: 500;
        text-align: center;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/public/confirm-dialog.vue